import { css } from '@emotion/css';
import React from 'react';
import { ReactComponent as MenuIcon } from 'src/assets/images/ic_tricolon.svg';

interface MenuButtonProps {
  onClick: () => void;
  backgroundColor?: string;
  activeColor?: string;
  ariaLabel?: string;
}

export const MenuButton: React.FC<MenuButtonProps> = ({
  onClick,
  backgroundColor,
  activeColor,
  ariaLabel
}) => {
  return (
    <button
      className={css`
        width: 44px;
        height: 44px;
        text-align: center;
        padding: 0;
        .menu-icon {
          display: inline-block;
          vertical-align: middle;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          transition: background-color 0.12s;
          background-color: ${backgroundColor ?? 'transparent'};
        }
        :active {
          .menu-icon {
            background-color: ${activeColor ?? 'rgba(236, 229, 212, 0.8)'};
          }
        }
      `}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <MenuIcon width={32} height={32} className="menu-icon" />
    </button>
  );
};
